(function () {
  'use strict';

  if (window.TELEMETRY_GUARD_DISABLED) { return; }
  if (window.__telemetryNoiseGuardInstalled) { return; }
  if (typeof window.fetch !== 'function') { return; }
  window.__telemetryNoiseGuardInstalled = true;

  // Hosts to watch. Add others here if their failures clutter the console
  // e.g. add 'www.clarity.ms' if you want that one silenced as well.
  var HOSTS = [
    'monorail-edge.shopifysvc.com',
    'error-analytics-sessions-production.shopifysvc.com'
  ];

  var ALWAYS_BLOCK = false;   // see the warning above before flipping this
  var STORAGE_KEY  = 'telemetry_unreachable_v1';

  var nativeFetch  = window.fetch.bind(window);
  var nativeBeacon = (window.navigator && typeof window.navigator.sendBeacon === 'function')
    ? window.navigator.sendBeacon.bind(window.navigator)
    : null;

  var down = readFlags();

  function log() {
    if (!window.TELEMETRY_GUARD_DEBUG) { return; }
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[telemetry-guard]');
    console.log.apply(console, args);
  }

  function readFlags() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function markDown(host) {
    down[host] = true;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(down));
    } catch (e) {
      /* private mode -- the in-memory flag still covers this page */
    }
    log('marked unreachable for this session:', host);
  }

  // Returns the watched host this URL belongs to, or '' if it is not one.
  function watchedHost(url) {
    if (!url) { return ''; }
    var host;
    try {
      host = new URL(String(url), window.location.href).hostname;
    } catch (e) {
      return '';
    }
    for (var i = 0; i < HOSTS.length; i++) {
      if (host === HOSTS[i]) { return host; }
    }
    return '';
  }

  function shouldSkip(host) {
    return ALWAYS_BLOCK || down[host] === true;
  }

  // What a swallowed telemetry call resolves to. 204 No Content is what these
  // endpoints effectively return, so callers treat it as a successful send.
  function noContent() {
    return new window.Response(null, { status: 204, statusText: 'No Content' });
  }

  /* ---------------------------------------------------------------- fetch */

  window.fetch = function (input, init) {
    var url = (typeof input === 'string')
      ? input
      : (input && typeof input.url === 'string' ? input.url : '');

    var host = watchedHost(url);
    if (!host) { return nativeFetch(input, init); }

    if (shouldSkip(host)) {
      log('skipped fetch to', host);
      return Promise.resolve(noContent());
    }

    // First attempt still reaches the network, so the browser still logs this
    // one failure. We record the host so nothing tries again this session.
    return nativeFetch(input, init).catch(function (err) {
      markDown(host);
      log('fetch failed, circuit opened for', host, err && err.message);
      return noContent();
    });
  };

  /* ----------------------------------------------------------- sendBeacon */

  if (nativeBeacon) {
    window.navigator.sendBeacon = function (url, data) {
      var host = watchedHost(url);
      if (!host) { return nativeBeacon(url, data); }

      if (shouldSkip(host)) {
        log('skipped beacon to', host);
        return true;   // report "queued" so callers do not fall back to XHR
      }

      var queued = false;
      try {
        queued = nativeBeacon(url, data);
      } catch (e) {
        queued = false;
      }
      if (!queued) {
        markDown(host);
        log('beacon refused, circuit opened for', host);
      }
      return queued;
    };
  }

  /* ------------------------------------------------------------------ XHR */

  // Shopify's bugsnag session ping uses XMLHttpRequest, so fetch/beacon alone
  // would miss it. When a watched host is already known to be unreachable we
  // simply never call the real send(): no request means no browser network
  // log. The XHR then stays pending forever, which is fine for fire-and-forget
  // telemetry -- we deliberately do NOT synthesise a completion, because
  // status/readyState are read-only and faking an error event just makes the
  // caller log its own failure message instead.
  if (typeof window.XMLHttpRequest === 'function' && window.XMLHttpRequest.prototype) {
    var xhrProto    = window.XMLHttpRequest.prototype;
    var nativeOpen  = xhrProto.open;
    var nativeSend  = xhrProto.send;

    xhrProto.open = function (method, url) {
      try {
        this.__telemetryHost = watchedHost(url);
      } catch (e) {
        this.__telemetryHost = '';
      }
      return nativeOpen.apply(this, arguments);
    };

    xhrProto.send = function () {
      var host = this.__telemetryHost;
      if (!host) { return nativeSend.apply(this, arguments); }

      if (shouldSkip(host)) {
        log('skipped XHR to', host);
        return;
      }

      // Let the first attempt run so we can learn the host is unreachable.
      var self = this;
      this.addEventListener('error', function () {
        markDown(host);
        log('XHR failed, circuit opened for', host);
      });
      return nativeSend.apply(self, arguments);
    };
  }

  log('installed for', HOSTS.join(', '));
})();
